import contentTypes, { ContentType } from "@/view/constants/contentTypes";

export function extractResults({
  data,
  limit,
  legacyFormat = false,
}: {
  data: Object | undefined;
  limit?: number;
  legacyFormat?: boolean;
}): Array<any> {
  if (!data) return [];

  let relatedContent = (data as Record<string, any>)["results"] || [];

  if (limit && relatedContent.length > limit) {
    relatedContent = relatedContent.slice(0, limit);
  }

  if (legacyFormat) {
    relatedContent = getLegacyFormat(relatedContent);
  }

  return relatedContent;
}

function getDeckContentType(contentType: ContentType) {
  let deck = contentType.toLowerCase();

  switch (contentType) {
    // NOTE: Include any other mappings as needed
    case contentTypes.ARTICLE:
      deck = "articleheader";
      break;
    default:
      break;
  }

  return deck;
}

function getLegacyFormat(data: Record<string, any>[]) {
  const DEFAULT_VALUES = {
    contentType: contentTypes.ARTICLE,
    gradeLevels: [],
    lexileLevels: [],
    liteExpiration: null,
    hasFormative: false,
    hasPowerWords: false,
    maturityRange: undefined as number[] | undefined,
    label: undefined as string | undefined,
    assetCountByContentType: undefined as { [key: string]: number } | undefined,
  };

  return data.map(
    ({
      display_date: datePublished,
      metadata: {
        content_type: contentType = DEFAULT_VALUES.contentType,
        date_lite_product_grant_expires:
          liteExpiration = DEFAULT_VALUES.liteExpiration,
        grade_levels: gradeLevels = DEFAULT_VALUES.gradeLevels,
        has_formative: hasFormative = DEFAULT_VALUES.hasFormative,
        lexile_levels: lexileLevels = DEFAULT_VALUES.lexileLevels,
        has_power_words: hasPowerWords = DEFAULT_VALUES.hasPowerWords,
        maturity_range: maturityRange = DEFAULT_VALUES.maturityRange,
        label = DEFAULT_VALUES.label,
        asset_count_by_content_type:
          assetCountByContentType = DEFAULT_VALUES.assetCountByContentType,
      } = {},
      ...item
    }) => ({
      ...item,
      content_id: item["id"],
      content_type: getDeckContentType(contentType),
      date_lite_product_grant_expires: liteExpiration,
      date_published: datePublished,
      has_formative: hasFormative,
      lexile_levels: lexileLevels,
      maturity_range: maturityRange,
      label,
      asset_count_by_content_type: assetCountByContentType,
      /**
       * NOTE: the properties below either do not exist in the new response
       * or are unreliable. Keeping them here for compatibility.
       */
      features: {
        available_in_spanish: undefined,
        has_power_words: hasPowerWords,
      },
      grade_level: gradeLevels.map((level: number) => `Grade ${level}`),
      image: item["images"]?.[0] || undefined,
      levels_ids_information: lexileLevels.map((lexile: number) => ({
        grade: undefined,
        id: undefined,
        language: undefined,
        lexile: `${lexile}L`,
      })),
      _score: undefined,
      content_maturities: undefined,
      content_provider: {
        name: "",
      },
      header_id: undefined,
      reading_skills: undefined, // metadata.reading_skills is set, but the string values are different
      slug: undefined,
      story_type: undefined,
      tags: undefined,
      visibility_markers: undefined,
      word_count: undefined,
    }),
  );
}
